import { messagesAdapter } from '../../reduxStore/adapters';
import { IAppState } from '../../reduxStore/store';
import { createDraftSafeSelector } from '@reduxjs/toolkit';

export const messagesStackSelectors = messagesAdapter.getSelectors<IAppState>(
	(state) => state.messagesStack,
);

export const getFirstMessageStack = createDraftSafeSelector(
	messagesStackSelectors.selectAll,
	(messages) => [...messages].shift(),
);

export const getAgentTypingMessage = (state: IAppState) =>
	state.messagesStack.agentTypingMessage;
